import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpXsrfTokenExtractor } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

var URL = environment.url_django;

@Injectable()
export class AuthenticationService {
    constructor(private http: HttpClient) { }
//    constructor(private http: HttpClient,
//    private tokenExtractor: HttpXsrfTokenExtractor) {}

    loginGetId(username: string, password: string) {
        // djoser /me/ returns information about the user
        let headers = new HttpHeaders({
            'Authorization': 'Basic ' +  btoa(username+':'+password)
        });

        return this.http.get(URL+'auth/me/', {
            headers: headers
        })
        .map(user => {
        console.log('loginGetId:user')
        console.log(user)
            localStorage.setItem('currentUserId', JSON.stringify(user));
            return user
        });
    }
    login(username: string, password: string) {
//        let headers = new HttpHeaders({
//            'Content-Type': 'application/x-www-form-urlencoded')
//        });
//        X-CSRFToken

//        const token = this.tokenExtractor.getToken() as string;
//        console.log('token:'+token);
//        ,headers: new HttpHeaders().set('X-XSRF-TOKEN', token)
        // djoser /token/create, returns a new Token generated by DRF

//        return this.http.get(URL+'pss_app/getcsrf')
//        .map(res => {

//          console.log('getcsrf:');
//          console.log(res);
//          let headers = new HttpHeaders();
//          headers.set('X-XSRF-TOKEN', res.toString());
        return this.http.post<any>(URL+'auth/token/login/', { username: username, password: password })
        .map(user => {
            console.log(user);
                // login successful if there's a jwt token in the response
                if (user && user.auth_token) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify(user));
                }

                return user;
            });

//        });


    }
    forgetPass(email: string) {
        return this.http.post<any>(URL+'auth/users/reset_password/', { email: email })
        .map(data => {
            console.log(data);
            return data;
        });
    }
    confirmPass(uid: string, token: string, new_password: string, re_new_password: string) {
        return this.http.post<any>(URL+'auth/users/reset_password_confirm/',
            { uid: uid, token: token, new_password: new_password, re_new_password: re_new_password })
        .map(data => {
            console.log(data);
            return data;
        });
    }
    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        localStorage.removeItem('currentUserId');
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/authentication.service.ts